import React from 'react';
import useGoogleSignIn from './useGoogleSignIn';

// This HOC takes a component and returns a new component with googleSignIn props
export function withGoogleSignIn(Component) {
  return function WrappedComponent(props) {
    const googleSignIn = useGoogleSignIn();
    return <Component {...props} googleSignIn={googleSignIn} />;
  };
}
